<template>
  <legal-page
    title="Política de Privacidad"
    :intro="`En ${business.name} valoramos y protegemos tu privacidad. Esta política describe qué datos recopilamos, cómo los usamos y cómo los protegemos.`"
  >
    <div class="legal-sections">
      <legal-section
        step="01"
        title="Información que recopilamos"
        icon="DatabaseIcon"
        variant="info"
      >
        <p>
          Datos de identificación y contacto (nombre, correo,
          teléfono), datos de tu contrato de servicio y la información
          necesaria para procesar tus pagos. Los datos completos de tu
          tarjeta son procesados directamente por nuestro proveedor de
          pagos (AZUL) y no son almacenados por {{ business.name }}.
        </p>
      </legal-section>

      <legal-section
        step="02"
        title="Uso de la información"
        icon="ActivityIcon"
      >
        <p>
          Utilizamos tus datos para gestionar tu cuenta, procesar
          pagos, emitir comprobantes y brindarte soporte. No vendemos
          ni cedemos tu información a terceros con fines comerciales.
        </p>
      </legal-section>

      <legal-section
        step="03"
        title="Terceros"
        icon="ExternalLinkIcon"
        variant="warning"
      >
        <p>
          El procesamiento de pagos se realiza a través de AZUL, que
          cumple con los estándares de seguridad de la industria
          (PCI-DSS). Te recomendamos revisar también sus políticas de
          privacidad.
        </p>
      </legal-section>

      <legal-section
        step="04"
        title="Seguridad"
        icon="LockIcon"
        variant="success"
      >
        <p>
          Aplicamos medidas técnicas y organizativas razonables,
          incluyendo cifrado SSL en tránsito, para proteger tu
          información. Consulta nuestras
          <b-link :to="{ name: 'legal-security' }">
            Políticas de Seguridad </b-link>.
        </p>
      </legal-section>

      <legal-section
        step="05"
        title="Tus derechos"
        icon="UserCheckIcon"
      >
        <p>
          Puedes solicitar acceso, rectificación o eliminación de tus
          datos escribiéndonos a
          <a :href="`mailto:${business.email}`">{{
            business.email
          }}</a>.
        </p>
      </legal-section>
    </div>
  </legal-page>
</template>

<script>
import { BLink } from "bootstrap-vue"
import business from "@/business"
import LegalPage from "./LegalPage.vue"
import LegalSection from "./LegalSection.vue"

export default {
  components: { LegalPage, LegalSection, BLink },
  data() {
    return { business }
  },
}
</script>
